module.exports = __webpack_public_path__ + "img/ennetix-xtend-alert-details-table.84bc3988.png";